<div class="card mt-4">
  <div class="card-body p-4">
    @if (showLinerServiceDiscountBanner()) {
      <app-alert
        class="d-block mb-3"
        summary="You may qualify for a liner service discount"
        detail="The selected carrier offers liner services. Apply for a possible discount below.">
      </app-alert>
    }

    <div class="d-flex flex-column">
      <app-form-field label="Is this visit part of a liner service?" [includeMargin]="false">
        <app-yes-no
          [formControl]="isPartOfLinerService"
          [required]="discountSelected()">
        </app-yes-no>
      </app-form-field>

      @if (showLinerService()) {
        <div class="card mt-4">
          <div class="card-body p-4">
            <div class="row g-4">
              <app-form-field class="col-6" label="Shipping company" [includeMargin]="false">
                <app-select
                  [optionsProvider]="shippingCompanyOptions"
                  [formControl]="shippingCompany"
                  [placeholder]="'Select a shipping company'"
                  [nullOption]="true"
                  [required]="showLinerService()"
                  [equalsFunction]="shippingCompaniesEqual"
                  [formatter]="shippingCompanyFormatter">
                </app-select>
              </app-form-field>
            </div>
            <div class="row g-4">
              <app-form-field class="col-6" label="Liner service" [includeMargin]="false">
                <app-select
                  [options]="linerServiceTypeCodes()"
                  [formControl]="linerServiceType"
                  [placeholder]="'Select a liner service'"
                  [required]="showLinerService()"
                  [formatter]="linerServiceFormatter">
                </app-select>
              </app-form-field>
            </div>
          </div>
        </div>
      }

      <app-form-field label="Combine visits on the invoice (2 is 1)?" [includeMargin]="false">
        <app-yes-no
          [formControl]="twoIsOne"
          [required]="discountSelected()">
        </app-yes-no>
      </app-form-field>
    </div>
  </div>
</div>
